export default __webpack_public_path__ + "static/media/product-app-2.ccc6aacf.png";